import { useState } from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import { DeleteManualReferralDialog } from '../../manual-referrals/DeleteManualReferralDialog';
import { ManualReferralModal } from '../../manual-referrals/ManualReferralModal';
import type { ReferralListRow } from '../../../types/engagement-metrics.types';

type ReferralRowActionsProps = { row: ReferralListRow };

const iconButtonClass = 'rounded-md p-1.5 text-gray-500 transition-colors disabled:opacity-50';

/**
 * Feature 117: per-row actions of the Referrals tab (manual rows only; the
 * tab already gates on MANAGE_USERS_AND_RESOURCES): Edit and Delete.
 */
export const ReferralRowActions = ({ row }: ReferralRowActionsProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  if (!row.manualReferralId) return null;

  const referrerName = row.referrer?.name ?? 'bQuest Concierge';
  const referredName = row.referred?.name ?? 'Unknown';

  return (
    <div className="flex items-center gap-0.5">
      <button
        type="button"
        onClick={() => setIsEditOpen(true)}
        className={`${iconButtonClass} hover:bg-gray-100 hover:text-[#15543e]`}
        aria-label={`Edit referral ${referrerName} → ${referredName}`}
        title="Edit referral"
      >
        <Pencil className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => setIsDeleteOpen(true)}
        className={`${iconButtonClass} hover:bg-red-50 hover:text-red-600`}
        aria-label={`Delete referral ${referrerName} → ${referredName}`}
        title="Delete referral"
      >
        <Trash2 className="h-4 w-4" />
      </button>

      {isEditOpen && (
        <ManualReferralModal
          open={isEditOpen}
          onOpenChange={setIsEditOpen}
          referralId={row.manualReferralId}
        />
      )}

      {isDeleteOpen && (
        <DeleteManualReferralDialog
          open={isDeleteOpen}
          onOpenChange={setIsDeleteOpen}
          referral={{
            id: row.manualReferralId,
            referrerName,
            referredName,
            careSeekerName: row.careSeeker?.name ?? null,
            referralDate: row.referralDate,
          }}
        />
      )}
    </div>
  );
};
